import { render } from "./MainServicesDGII.vue?vue&type=template&id=3d769a54&scoped=true"
import script from "./MainServicesDGII.vue?vue&type=script&lang=js"
export * from "./MainServicesDGII.vue?vue&type=script&lang=js"

import "./MainServicesDGII.vue?vue&type=style&index=0&id=3d769a54&scoped=true&lang=css"

import exportComponent from "D:\\Sistema\\Nueva carpeta\\front-api\\erp-front\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3d769a54"]])

export default __exports__